import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import Footer from './../../components/footer/Footer'
import Navigation from './../../components/navigation/Navigation'
import Banner from './../../components/banner/banner';
import TechnologyCard from '../../components/technology-card/technology-card';
import { NETSUITETHUMB, NETSUITE, NETSUITEBG } from './../../assets/images/index'
import SEO from './../../components/seo/SEO'

const Netsuite = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div>
        <SEO
          title="NetSuite"
          description="Triumphal delivers NetSuite implementation and customization services to help enterprises unify financials, operations, and customer data on one platform."
          path="/technology/netsuite"
          keywords="NetSuite development, NetSuite integration, ERP"
        />
        <Navigation show={show} onClose={handleClose} onShow={handleShow} />
        <Banner title="Netsuite" bg={NETSUITEBG} />
        <Container>
          <div>
            <TechnologyCard title="Netsuite"
              content1="	
	
Triumphal and its partners help improve visibility and control over every aspect of your business, across industries and geographies using NetSuite."
              content2="	
	
Triumphal capabilities in NetSuite is backed by a strong bench of technical and domain experts spread across geographies. From implementing an accounting module to an end-to-end ERP application in NetSuite, 	
	
Triumphal can help optimize the value of your spend."
              image={NETSUITETHUMB}
              deliveryimg={NETSUITE} />
          </div>
        </Container>
        <Footer />
      </div>
    </>
  )
}

export default Netsuite
